import React from 'react';

import 'react-modal-video/scss/modal-video.scss';
import ContactModal from "../ContactModal";

function Main2() {

    return (
            <section className="about-section-two style-two layout-pt-60 layout-pb-60 js-tab-menu-content page-lahalle"
                     style={{background: '#E7ECFF80', position: 'relative', overflow: 'visible'}}>
                <div className="auto-container">
                    <div className="row grid-base align-items-center g-5">
                        <div className="image-column -no-margin col-xl-5 offset-xl-2 col-lg-5 offset-lg-1 col-md-12 col-sm-12">
                            <figure className="image-box image-responsive" style={{width:'115%'}}>
                                <img src="/images/lahalle/images.webp" alt="Pourquoi ce services" style={{position: 'initial'}} />
                            </figure>
                        </div>
                        <div className="content-column col-xl-5 col-lg-6 col-md-12 col-sm-12 wow fadeInRight">
                            <div className="wow fadeInLeft">
                                <div className="sec-title raleway">
                                    <h2 className="fw-700">Pourquoi <span>ce service ?</span></h2>
                                </div>
                                <div className="text nunito">
                                    Chez Incluvia, nous sommes engagés pour <strong>que le handicap ne soit jamais un frein à
                                    l’emploi ou à l’évolution professionnelle</strong>. Ce service répond à un triple constat :

                                    <div className="text mt-3 mb-3">
                                        <ul className="list-style-disc">
                                            <li>
                                                Le handicap reste mal connu et souvent entouré de préjugés.
                                            </li>
                                            <li>
                                                <b>80% des situations de handicap sont invisibles</b>... et souvent tues, par crainte ou méconnaissance.
                                            </li>
                                            <li>
                                                Beaucoup de collaborateurs ne se sentent pas concernés, alors qu’ils le sont parfois sans le savoir
                                            </li>
                                        </ul>
                                    </div>
                                    La <b>Hotline Handicap</b> permet à chacun d’obtenir <strong>des réponses claires, dans un cadre neutre et bienveillant</strong>.

                                </div>

                                <ContactModal textButton="Comment ça marche ?"
                                              showText={false}
                                              small="small"
                                              linkPageContact={false}
                                              iframe={false}
                                              couleur={false}
                                              page="incluvia"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
    );
}

export default Main2;
